import React, { Component, PropTypes } from "react";

import styled from "styled-components";

const MeterSeperator = styled.li`
	margin: 0;

	section{
    height: 8px;
    border-left: 1px solid #BBBBBB;
    div{
	  			font-size:10px;
	  			margin-top:20px;
	  			margin-left:-14px;
	  			position:absolute;
	  			color:#BBBBBB;
	  			font-weight:600;
			}
	}
	&:nth-child(odd) section
		{
	  		height:15px;
	  		border-left: 1px solid #BBBBBB;

	  		div
			{
	  			font-size:10px;
	  			margin-top:20px;
	  			margin-left:-14px;
	  			position:absolute;
	  			color:#BBBBBB;
	  			font-weight:600;
			}

		}
`;

const Meter = styled.ul`
  padding:0;
  width:${props => props.width}%;
  opacity:1;
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow-y:no-scroll;
  flex-shrink: 0;
  `;

 const MeterSeperatorContent = styled.div`
 white-space: nowrap;
 `;

const MeterScale = ({ metric, min, max, interval, metricPadding, width }) => {

	return (
		<Meter width={width}>
			{interval.map(function(item, i) {
				return (
					<MeterSeperator metricPadding={metricPadding} key={i}>
						<section><MeterSeperatorContent>{item.Display} {item.Display? metric:''}</MeterSeperatorContent></section>
					</MeterSeperator>
				);
			})}
		</Meter>
	);
};

MeterScale.defaultProps = {
	metricPadding: 35,
	width:99
};

MeterScale.propTypes = {
	metric: PropTypes.string,
	min: PropTypes.string,
	max: PropTypes.string,
	interval: PropTypes.array,
	metricPadding: PropTypes.number,
	width: PropTypes.number,
	left:PropTypes.number,
};

export default MeterScale;



// WEBPACK FOOTER //
// ./src/components/comparison/MeterScale.js